import React, { Dispatch, useContext, useEffect, useMemo, useRef } from 'react';
import DatePicker from 'react-datepicker';
import format from 'date-fns/format';
import { Heading } from '@lili/lili-frontend-common';
import { PROFIT_AND_LOSS_STYLES } from '../constants';
import { useStore } from '../../../store';
import { ProfitAndLossContext } from '../pages';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/svg/shared/ic-shared-calendar.svg';
import { ProfitAndLossPeriodType } from '../constants/types';

interface IProps {
  showDatePicker: boolean;
  setShowDatePicker: Dispatch<React.SetStateAction<any>>;
  handleToggleDropdown: (filterType: string) => void;
  startDate: Date | null;
  endDate: Date | null;
  onChange: (dates: Date[]) => void;
}

export const PeriodDatepickerFilter = ({
  showDatePicker,
  handleToggleDropdown,
  startDate,
  endDate,
  onChange,
  setShowDatePicker,
}: IProps) => {
  const {
    customer: { createTime },
  } = useStore((state) => state.summary);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const FlowContext = useContext(ProfitAndLossContext);

  const handleClickOutside = (event: Event) => {
    if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node)) {
      setShowDatePicker((prevState: boolean) => !prevState);
    }
  };

  const isNotCustom = useMemo(
    () => FlowContext?.filterObject.period?.periodType !== ProfitAndLossPeriodType.CUSTOM,
    [FlowContext?.filterObject.period?.periodType],
  );

  const inputValue = () => {
    if (isNotCustom) {
      return `${format(new Date(FlowContext?.filterObject.period?.startDate || ''), 'MMM dd')} - ${format(new Date(FlowContext?.filterObject.period?.endDate || ''), 'MMM dd')}`;
    }
    if (!startDate) {
      return '';
    }
    if (!endDate) {
      if (FlowContext?.filterObject.period?.endDate === null) {
        return `${format(new Date(startDate), 'MMM dd')} - `;
      }
      return `${format(new Date(startDate), 'MMM dd')} - ${format(new Date(FlowContext?.filterObject.period?.endDate!), 'MMM dd')}`;
    }
    return `${format(new Date(startDate), 'MMM dd')} - ${format(new Date(endDate), 'MMM dd')}`;
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });
  return (
    <div className='border-[1px] border-outline-primary-bw-03 hover:border-outline-primary-bw-07 outline-none w-[187px] h-[40px] rounded-r-[8px] relative '>
      <div className='flex items-center gap-2  px-[12px] rounded-r-[8px] hover:bg-bw02 h-full'>
        <CalendarIcon className='w-[20px] h-[20px]  text-bw08' />
        <button
          id='dateFilterButton'
          type='button'
          className='w-full'
          onClick={() => handleToggleDropdown('minMaxDateType')}
        >
          <Heading.H10 id='dateFilterTitle' className='w-full text-left'>
            {inputValue()}
          </Heading.H10>
        </button>
      </div>

      {showDatePicker && (
        <div className={PROFIT_AND_LOSS_STYLES.DATEPICKER} ref={datePickerRef}>
          <DatePicker
            // @ts-ignore
            onChange={onChange}
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
            minDate={new Date(createTime.toString())}
            maxDate={new Date()}
            dropdownMode='select'
            showMonthDropdown
            showYearDropdown
            selectsRange
            dateFormat='MMM d, yyyy'
            inline
          />
        </div>
      )}
    </div>
  );
};
